<template>
  <basic-card>
    <template slot="header">
          {{ displayName }}
    </template>
    <toolbox>
      <toolbox-button @press="loadData" :help-text="$t('refresh')">
        <icon :icon="['fal', 'sync']"/>
      </toolbox-button>
    </toolbox>
    <data-table :data="files"
                :configuration="tableConfig"
                :component-id="`widget-${displayName}`"
                @download="handleDownload"
    ></data-table>
  </basic-card>
</template>

<script>
import BasicCard from "@/components/layout/BasicCard";
import Axios from "axios";
import DataTable from "@/components/table/DataTable";
import SimpleButton from "@/components/button/SimpleButton";
import Toolbox from "@/components/toolbox/Toolbox";
import ToolboxButton from "@/components/toolbox/ToolboxButton";

export default {
  name: "SimpleProcessHistoryWidget",
  components: {ToolboxButton, Toolbox, SimpleButton, DataTable, BasicCard},
  props: {
    displayName: String,
    dateFrom: String,
    dateTo: String,
    category: String,
    customName: String
  },
  data: function () {
    return {
      files: [],
      tableConfig: {
        enableCheck: true,
        allowEdit: true,
        enableAdd: false,
        columns: [
          {
            caption: this.$t('files.fileName'),
            datum: d => d.fileName
          },
          {
            caption: this.$t('files.mimeType'),
            datum: d => d.mimeType
          },
          {
            caption: this.$t('files.timeStamp'),
            datum: d => new Date(d.timeStamp).toLocaleString()
          },
          {
            caption: this.$t('files.category'),
            datum: d => d.category
          },
          {
            caption: this.$t('files.customName'),
            datum: d => d.customName
          }
          // ,
          // {
          //   caption: "ID",
          //   datum: d => d.id
          // }
        ],
        actions: [
          {
            icon: 'download',
            name: 'download',
            accessLambda: (d) => true,
            tooltip: this.$t('files.download')
          }
        ]
      }
    }

  },
  methods: {
    async loadData() {
      const searchQuery = {
        name: "",
        object: "file",
        parameters: {
          category: this.category ? {value: this.category, operator: "eq", negation: false, type: "string"} : undefined,
          customName: this.customName ? {value: this.customName, operator: "eq", negation: false, type: "string"} : undefined,
          uploadTime: this.dateFrom || this.dateTo ? {value: `${this.dateFrom ? this.dateFrom : "-2soy"};${this.dateTo ? this.dateTo : "2eoy"}`, operator: "range", negation: false, type: "date"} : undefined
        }
      }
      const searchQueryString = encodeURIComponent(JSON.stringify(searchQuery));
      const response = await Axios.get(`/resource/api/v1/files/search?query=${searchQueryString}&size=10000`,);
      this.files = response.data
    },
    handleDownload(file) {
      Axios.get(`/resource/api/v1/files/${file.id}/data`, {
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
